<template>
  <div>
    <breadcrumb v-bind:path2="path2"></breadcrumb>
    <div class="warehouseOrder">
      <el-form ref="orderForm" :model="orderForm">
        <div class="wrap">
          <div class="main">
            <main class="main__content">
              <div class="step__sections" v-if="!submmited">
                <div class="section section--shipping-address">
                  <!-- customer information start-->
                  <div class="section__content" v-bind:style="{ marginBottom: 10 }">
                    <div class="title">
                      <span>{{ $t("customerInfo") }}</span>
                    </div>
                    <div class="fieldset">
                      <!-- <el-row>
                        <span>{{ $t("orderDate") }} : {{ new Date().toLocaleDateString("en") }}</span>
                      </el-row> -->
                      <el-row :gutter="20">
                        <!-- <el-col :span="8">
                          <el-form-item v-bind:label="$t('orderDate')" prop="OrderDate">
                            <el-date-picker
                              v-model="orderForm.OrderDate"
                              type="date"
                              format="MM/dd/yyyy"
                              value-format="yyyy-MM-dd"
                              style="width:100%"
                              placeholder="MM/DD/YYYY"
                            >
                            </el-date-picker>
                          </el-form-item>
                        </el-col> -->
                        <el-col :span="8">
                          <el-form-item v-bind:label="$t('pickupDate')" prop="ShipmentDate">
                            <el-date-picker
                              v-model="orderForm.ShipmentDate"
                              type="date"
                              format="MM/dd/yyyy"
                              value-format="yyyy-MM-dd"
                              style="width:100%"
                              placeholder="MM/DD/YYYY"
                            >
                            </el-date-picker>
                          </el-form-item>
                        </el-col>
                        <el-col :span="8">
                          <el-form-item v-show="orderForm.Carrier==='fedex'" v-bind:label="$t('signature')" prop="Signature">
                            <el-select
                              filterable
                              value-key="id"
                              v-model="orderForm.Signature"
                            >
                              <el-option
                                v-for="option in signatureOptions"
                                :label="`${option}`"
                                :value="option"
                                :key="option"
                              >
                              </el-option>
                            </el-select>
                          </el-form-item>
                        </el-col>
                      </el-row>
                      <el-row :gutter="20">
                        <el-col :span="16">
                          <div>
                            <el-form-item v-bind:label="$t('pickupLocation')" prop="Pickup_Warehouse_id">
                              <el-select
                                filterable
                                v-model="orderForm.Pickup_Warehouse_id"
                              >
                                <el-option
                                  v-for="address in warehouseAddresses"
                                  :label="`${address.formatted_address}`"
                                  :value="address.id"
                                  :key="address.id"
                                >
                                </el-option>
                              </el-select>
                            </el-form-item>
                          </div>
                        </el-col>
                        <el-col :span="8">
                        </el-col>
                      </el-row>
                      <el-row :gutter="20">
                        <el-col :span="16">
                          <div>
                            <el-form-item v-bind:label="$t('deliveryLocation')" prop="Billing_CustomerDetail_id">
                              <el-select
                                filterable
                                v-model="orderForm.Billing_CustomerDetail_id"
                              >
                                <el-option
                                  v-for="address in billingAddresses"
                                  :label="`${address.Street} ${address.City} ${address.State} ${address.Zip}`"
                                  :value="address.CustomerDetail_id"
                                  :key="address.CustomerDetail_id"
                                >
                                </el-option>
                              </el-select>
                            </el-form-item>
                          </div>
                        </el-col>
                        <el-col :span="8">
                          <div class="title">
                            <button class="btn" @click.prevent="addressModalVisible = true">
                              <i class="el-icon-plus"></i><span>{{ $t("addNewAddress") }}</span>
                            </button>
                          </div>
                        </el-col>
                      </el-row>
                    </div>
                  </div>
                  <!-- end customer information -->
                  
                  
                  <!-- order info start -->
                  <div class="section__content" v-bind:style="{ marginBottom: 10 }">
                    <div class="title">
                      <span>{{ $t("orderInfo") }}</span>
                    </div>
                    <div class="fieldset">
                      <div class="customerInfoTable">
                        <el-row :gutter="20">
                          <el-col :span="6">
                            <el-form-item v-bind:label="$t('PDF file')">
                              <el-upload
                                :multiple="false"
                                :limit="1"
                                action=""
                                :on-remove="handleFileRemove"
                                :before-remove="beforeFileRemove"
                                :on-change="handleFileImport"
                                :auto-upload="false">
                                <el-button
                                  icon="el-icon-document"
                                  type="primary"
                                  circle>
                                </el-button>
                              </el-upload>
                            </el-form-item>
                          </el-col>
                        </el-row>
                        
                        <el-table
                          ref="multipleTableRef"
                          :data="inboundProducts"
                          style="width: 100%; marginBottom: 30px"
                          @selection-change="handleSelectionChange"
                          scrollbar-always-on
                          max-height="270"
                        >
                          <el-table-column type="selection" width="55" />
                          <el-table-column :label="$t('sku')" width="120">
                            <template #default="scope">{{ scope.row.RefNum }}</template>
                          </el-table-column>
                          <el-table-column property="Name" :label="$t('productName')" width="120" />
                          <el-table-column property="ProductNum" :label="$t('ProductNum')" show-overflow-tooltip />
                          <el-table-column property="Quantity" :label="$t('quantity')" show-overflow-tooltip />
                          <el-table-column property="BoxWeight" :label="$t('unitWeight')" show-overflow-tooltip />
                          <el-table-column property="NMFCClass" :label="$t('freightClass')" show-overflow-tooltip />
                          <el-table-column property="Remark" :label="$t('description')" show-overflow-tooltip />
                        </el-table>
                        <el-button
                          type="primary"
                          icon="el-icon-plus"
                          circle
                          @click="addNewLine"
                        ></el-button>
                        
                        <el-table
                          :data="orderForm.lines"
                          border
                          style="width: 100%; marginTop: 30px">
                          <el-table-column :label="$t('sku')" width="180">
                            <template slot-scope="scope">
                              <el-input disabled v-model="scope.row.RefNum"></el-input>
                            </template>
                          </el-table-column>
                          <el-table-column :label="$t('productName')" width="180">
                            <template slot-scope="scope">
                              <el-input disabled v-model="scope.row.Name"></el-input>
                            </template>
                          </el-table-column>
                          <el-table-column :label="$t('ProductNum')" width="180">
                            <template slot-scope="scope">
                              <el-input disabled v-model="scope.row.ProductNum"></el-input>
                            </template>
                          </el-table-column>
                          <el-table-column
                            :label="$t('quantity')"
                            width="150"
                            prop="palletCount">
                            <template slot-scope="scope">
                              <el-input-number
                                style="width: 110px"
                                v-model="scope.row.Quantity"
                                controls-position="right"
                                :min="0"
                                :max="scope.row.AvailableQuantity"
                              ></el-input-number>
                            </template>
                          </el-table-column>
                          <el-table-column :label="$t('unitWeight')" width="150">
                            <template slot-scope="scope">
                              <el-input disabled style="width: 60px" v-model="scope.row.BoxWeight"></el-input>
                            </template>
                          </el-table-column>
                          <el-table-column :label="$t('freightClass')" width="180">
                            <template slot-scope="scope">
                              <el-input disabled v-model="scope.row.NMFCClass"></el-input>
                            </template>
                          </el-table-column>
                          <el-table-column :label="$t('description')" width="180">
                            <template slot-scope="scope">
                              <el-input disabled v-model="scope.row.Remark"></el-input>
                            </template>
                          </el-table-column>
                          <el-table-column label="Action" width="70">
                            <template slot-scope="scope">
                              <el-button
                                icon="el-icon-delete"
                                type="primary"
                                circle
                                @click.native.prevent="deleteRow(scope.$index,orderForm.lines)"
                              >
                              </el-button>
                            </template>
                          </el-table-column>
                        </el-table>
                      </div>
                    </div>
                  </div>
                  <!-- add address -->
                  <el-dialog
                    v-bind:title="$t('addNewAddress')"
                    :visible.sync="addressModalVisible"
                    @close="handleClose"
                    class="modal"
                  >
                    <el-form
                      ref="addAddressForm"
                      :model="addAddressForm"
                    >
                      <div class="fieldset">
                        <div class="field">
                          <div v-if="errorAdding" class="time_tip">
                            <span>{{ $t("correctErrors") }}</span>
                          </div>
                          <el-row :gutter="20">
                            <el-col :span="12">
                              <div class="width">
                                <el-form-item
                                  prop="FirstName"
                                  v-bind:label="$t('firstName')"
                                >
                                  <el-input
                                    v-bind:placeholder="$t('firstName')"
                                    v-model="addAddressForm.FirstName"
                                  ></el-input>
                                </el-form-item>
                              </div>
                            </el-col>
                            <el-col :span="12">
                              <div class="width">
                                <el-form-item
                                  prop="LastName"
                                  v-bind:label="$t('lastName')"
                                >
                                  <el-input
                                    v-bind:placeholder="$t('lastName')"
                                    v-model="addAddressForm.LastName"
                                  ></el-input>
                                </el-form-item>
                              </div>
                            </el-col>
                          </el-row>
                          <el-row :gutter="20">
                            <el-col :span="12">
                              <div>
                                <el-form-item
                                  prop="AddressName"
                                  v-bind:label="$t('companyName')"
                                >
                                  <el-input
                                    v-bind:placeholder="$t('companyName')"
                                    v-model="addAddressForm.AddressName"
                                  ></el-input>
                                </el-form-item>
                                </div>
                              </el-col>
                            <el-col :span="12">
                              <div class="width">
                                <el-form-item
                                  prop="Telephone"
                                  v-bind:label="$t('phoneNumber')"
                                >
                                  <el-input
                                    v-bind:placeholder="$t('phoneNumber')"
                                    v-model="addAddressForm.Telephone"
                                    @input="phoneXPOFormatter(addAddressForm.Telephone)"
                                  ></el-input>
                                </el-form-item>
                              </div>
                            </el-col>
                          </el-row>
                          <el-row :gutter="20">
                            <el-col :span="24">
                              <el-form-item
                                prop="Residential"
                                v-bind:label="$t('Residential')"
                              >
                                <el-radio-group v-model="addAddressForm.Residential">
                                  <el-radio :label="true">Yes</el-radio>
                                  <el-radio :label="false">No</el-radio>
                                </el-radio-group>
                              </el-form-item>
                            </el-col>
                          </el-row>
                          <div class="two">
                            <div class="width">
                              <div>
                                <el-form-item
                                  prop="Street"
                                  v-bind:label="$t('street')"
                                >
                                  <el-input
                                    v-bind:placeholder="$t('street')"
                                    v-model="addAddressForm.Street"
                                  ></el-input>
                                </el-form-item>
                              </div>
                            </div>
                          </div>
                          <div class="three">
                            <div class="width_30">
                              <div>
                                <el-form-item
                                  prop="City"
                                  v-bind:label="$t('city')"
                                >
                                  <el-input
                                    v-bind:placeholder="$t('city')"
                                    v-model="addAddressForm.City"
                                  ></el-input>
                                </el-form-item>
                              </div>
                            </div>
                            <div class="width_30">
                              <div>
                                <el-form-item
                                  prop="State"
                                  v-bind:label="$t('state')"
                                >
                                  <el-select
                                    v-model="addAddressForm.State"
                                    v-bind:placeholder="$t('pleaseSelect')"
                                    value=""
                                  >
                                    <el-option
                                      v-for="item in stateOptions"
                                      :key="item.value"
                                      :label="item.label"
                                      :value="item.value"
                                    >
                                    </el-option>
                                  </el-select>
                                </el-form-item>
                              </div>
                            </div>
                            <div class="width_30">
                              <div>
                                <el-form-item
                                  prop="Zip"
                                  v-bind:label="$t('zipCode')"
                                >
                                  <el-input
                                    v-bind:placeholder="$t('zipCode')"
                                    v-model="addAddressForm.Zip"
                                  ></el-input>
                                </el-form-item>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div class="end">
                          <button
                            class="btn"
                            @click="submitNewAddress(addAddressForm, $event)"
                          >
                            {{ $t("submit") }}
                          </button>
                        </div>
                      </div>
                    </el-form>
                  </el-dialog>
                  <!-- add address end -->
                  <!-- order info end -->
                </div>
                <button
                  class="place btn"
                  @click="onSubmit(orderForm, $event)"
                >
                  {{ $t("submit") }}
                </button>
              </div>
            </main>
          </div>
        </div>
      </el-form>
    </div>
  </div>
</template>

<script>
  import {mapState, mapMutations, mapActions} from "vuex";
  import {Alert} from "element-ui";
  import axios from "axios";
  import breadcrumb from "../../components/breadcrumb";
  import logo from "../../assets/img/logo.png";
  import addresses from "../../store/modules/addresses";
  import {deleteCustomerDetail} from "../../store/modules/addresses";
  import {validateUSZipCode, validatePhoneNumber} from "../../../config/validation";

  export default {
    name: "upsFedex",
    components: {
      breadcrumb,
    },
    data() {
      return {
        errors: [],
        stateOptions: this.$store.state.addresses.states,
        multipleSelection: [],
        lableFile: [],
        signatureOptions: ['none','adult','direct'],
        

        // Order form data
        orderForm: {
          //customer info
          // OrderDate: "",
          ShipmentDate: "",
          Carrier: "fedex",
          Signature: "",
          Pickup_Warehouse_id: "",
          SelfDrayage: false,
          // ShipFrom: "",
          Deliver_CustomerDetail_id: "",
          IsOutbound: true,
          //ship info
          lines: [],
          totalWeight: 0,
        },
        
        // add address data
        addressModalVisible: false,
        errorAdding: false,
        addAddressForm: {
          Type: "Billing",
          FirstName: "",
          LastName: "",
          Residential: true,
          Street: "",
          Telephone: "",
          Email: "",
          City: "",
          Zip: "",
          Country: "United States",
          State: "",
          AddressName: "",
          AptNumber: "",
        },
        
        errorSubmitting: false,
        success: false,
        submmited: false,
        path2: this.$t("header3"),
      };
    },
    computed: mapState({
      inboundProducts: state => state.orders.inboundProducts,
      billingAddresses: (state) => state.addresses.billingAddresses,
      warehouseAddresses: (state) => state.addresses.warehouseAddresses,
    }),
    methods: {
      ...mapActions("orders", [ "submit", "submitOutboundLabel" ]),
      ...mapMutations("warehouseOrder", ["getOrderDetail"]),
      addNewLine() {
        if (this.multipleSelection) {
          this.multipleSelection.forEach(row => {
            if (row) {
              this.orderForm.lines.unshift({...row});
            }
          });
        }
      },
      deleteRow(index, rows) {
        rows.splice(index, 1);
      },
      // address method
      resetForm() {
        this.addAddressForm = {
          Type: "Billing",
          FirstName: "",
          LastName: "",
          Residential: true,
          Street: "",
          Telephone: "",
          Email: "",
          City: "",
          Zip: "",
          Country: "United States",
          State: "",
          AddressName: "",
        };
      },
      handleClose(event) {
        event.preventDefault();
        this.$refs['addWarehouseAddressForm'].resetForm();
        this.addressModalVisible = false;
      },
      checkAddressForm: async function (form) {
        this.errors = [];
        if (!form.Street) {
          this.errors.push(this.$t("addressRequired"));
        }
        if (!form.City) {
          this.errors.push(this.$t("cityRequired"));
        }
        if (!form.Country) {
          this.errors.push(this.$t("countryRequired"));
        }
        if (!form.State) {
          this.errors.push(this.$t("stateRequired"));
        }
        if (!form.AddressName) {
          this.errors.push(this.$t("companyNameRequired"));
        }
        if (validateUSZipCode(form.Zip)) this.errors.push(this.$t("zipCodeWrong"));
      },
      phoneXPOFormatter(value) {
        // NNN-NNNNNNN
        var cleaned = ('' + value).replace(/\D/g, '');
        var match = cleaned.match(/^(\d{3})(\d{3})(\d{4})$/);
        
        if (match) {
          this.addAddressForm.Telephone = match[1] + '-' + match[2] + match[3];
          // return match[1] + '-' + match[2] + match[3];
        }
      },
      submitNewAddress(address, event) {
        this.errors = []
        event.preventDefault();
        this.checkAddressForm(address);
        
        if (!this.errors.length) {
          this.$store.dispatch("addresses/postAddress", address).then(() => {
            this.$store.dispatch("addresses/fetchAddresses");
            this.resetForm();
            this.addressModalVisible = false;
          });
        } else {
          alert(this.errors);
        }
      },
      // Method for file
      handleFileImport(file, fileList) {
        this.lableFile = fileList;
        // this.updateFileList(fileList, 0); 
      },
      beforeFileRemove(file, fileList) {
        return this.$confirm(`Remove ${ file.name } ?`);
      },
      handleFileRemove(file, fileList) {
        this.lableFile = [];
        // this.updateFileList(fileList, 0);
      },
      updateFileList(fileList, id) {
        var formData = new FormData();
        formData.append('file', fileList[0].raw);
        this.submitOutboundLabel([formData, id]);
      },
      handleSelectionChange(rows) {
        this.multipleSelection = rows;
      },
      checkTable(lines) {
        if (lines.length === 0) {
          this.errors.push("Please select product.");
        } 
        const check = lines.every(element => element.BoxWeight === '' || element.BoxWeight === '0');
        if (check === true) {
          this.errors.push("a valid number is required for unit weight");
        }
      },
      onSubmit(orderForm, event) {
        event.preventDefault();
        this.errors = [];
        this.errorSubmitting = false;
        this.checkTable(orderForm.lines);
        
        // if (orderForm.OrderDate) {
        //   orderForm.OrderDate = moment(orderForm.OrderDate).format();
        // }
        if (orderForm.ShipmentDate) {
          orderForm.ShipmentDate = moment(orderForm.ShipmentDate).format();
        }
        
        orderForm.Deliver_CustomerDetail_id = orderForm.Billing_CustomerDetail_id;
        
        if (this.lableFile.length > 0) {
          orderForm.SelfDrayage = true;
        }
        // check
        if (!this.errors.length) {
          this.submit(orderForm)
            .then((res) => {
              this.errors = "";
              if (this.lableFile.length > 0) {
                this.updateFileList(this.lableFile, res.data.SalesOrder_id);
              }
              this.openAlert(res.data.SalesOrder_id); // show success message
            })
            .catch((err) => {
              alert(err.response.data.message);
            });
        } else {
          this.errorSubmitting = true;
          alert(this.errors);
        }
      },
      openAlert(id) {
        // this.submmited = true;
        let message = "You have submitted an outbound order.";
        this.$alert(message, "Success", {
          confirmButtonText: "Go to order detail",
          type: "success",
          center: true,
        }).then(() => {
          this.$router.push({name: 'order', params: {order_id: id}});
        });
      },
    },
    mounted() {
      this.$store.dispatch('orders/fetchInboundProducts');
      this.$store.dispatch("addresses/fetchAddresses");
      this.$store.dispatch("addresses/fetchWarehouseAddresses");
    },
  };
</script>

<style lang="less">
  @import "../../assets/css/warehouseOrder.less";
</style>



// WEBPACK FOOTER //
// src/view/Service/upsFedex.vue